export default "__VITE_ASSET__CN1_U4nM__"